export const colorType = {
  GRAY: 'GRAY',
  YELLOW: 'YELLOW',
  BLUE: 'BLUE',
};
